import { render, staticRenderFns } from "./MagSubmenuItemGroup.vue?vue&type=template&id=1f213bf0&scoped=true"
import script from "./MagSubmenuItemGroup.vue?vue&type=script&lang=js"
export * from "./MagSubmenuItemGroup.vue?vue&type=script&lang=js"
import style0 from "./MagSubmenuItemGroup.vue?vue&type=style&index=0&id=1f213bf0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f213bf0",
  null
  
)

export default component.exports